import React, { createContext, useState, useContext, useEffect } from 'react';
import { fetchProfileImage } from '../api/profile_related_service';
import Cookies from 'js-cookie';

// Create the context
const ProfilePictureContext = createContext();

// Create a provider component
export const ProfilePictureProvider = ({ children }) => {
  const [profilePicture, setProfilePicture] = useState(null);
  const user_token = process.env.REACT_APP_MODE === "development"
    ? localStorage.getItem("user_tk")
    : Cookies.get("connectedMe");

  // Fetch the profile image initially
  useEffect(() => {
    const fetchImage = async () => {
      try {
        if (user_token) {
          const imageUrl = await fetchProfileImage({ user_token });
          setProfilePicture(imageUrl);
        }
      } catch (error) {
        console.error("Error fetching profile image:", error);
      }
    };
    fetchImage();
  }, [user_token]);

  // Function to update profile picture that can be called from any component
  const updateProfilePicture = (newPictureUrl) => {
    setProfilePicture(newPictureUrl);
  };

  // Function to clear the profile picture
  const clearProfilePicture = () => {
    setProfilePicture(null);
  };

  return (
    <ProfilePictureContext.Provider 
      value={{ 
        profilePicture, 
        updateProfilePicture, 
        clearProfilePicture 
      }}
    >
      {children}
    </ProfilePictureContext.Provider>
  );
};

// Custom hook to use the profile picture context
export const useProfilePicture = () => {
  const context = useContext(ProfilePictureContext);
  if (!context) {
    throw new Error('useProfilePicture must be used within a ProfilePictureProvider');
  }
  return context;
};